import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { ApiModelStrategy } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';

@Component({
  templateUrl: './strategy-pick.component.html',
  styleUrls: ['./strategy-pick.component.scss'],
  standalone: false
})

export class StrategyPickComponent implements OnInit {
  public constructor(
    private restApiService: RestApiService,
    private loggerService: LoggerService,
    private toastService: ToastNotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public modelStrategies: ApiModelStrategy[] | null = null;
  public modelStrategiesPreloader = true;
  public canCreateEfektika = false;

  public ngOnInit(): void {
    this.canCreateEfektika = this.route.snapshot.data['canCreateEfektika'] ?? false;
    this.loadData();
  }

  private loadData(): void {
    this.restApiService.getModelStrategiesWithInstrumentsCategoriesFilter().subscribe({
      error: this.handleModelStrategiesError.bind(this),
      next: this.handleModelStrategiesData.bind(this),
    });
  }

  public routeToNew(): void {
    this.router.navigate(['/strategy/new']);
  }

  private handleModelStrategiesError(error: unknown): void {
    this.modelStrategiesPreloader = false;
    this.loggerService.error(typeof error === 'function' ? error() : error);
    this.toastService.unknownApiError();
  }

  private handleModelStrategiesData(data: ApiModelStrategy[]): void {
    this.modelStrategiesPreloader = false;
    this.modelStrategies = data;
  }
}
